interface LockIconProps {
  size?: number;
  color?: string;
}

const LockIcon = ({ size = 10, color = "currentColor" }: LockIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6.7 4H3.3C2.85817 4 2.5 4.35817 2.5 4.8V7.2C2.5 7.64183 2.85817 8 3.3 8H6.7C7.14183 8 7.5 7.64183 7.5 7.2V4.8C7.5 4.35817 7.14183 4 6.7 4Z"
      stroke={color}
      strokeOpacity={0.5}
      strokeWidth={0.8}
    />
    <path
      d="M3.7998 4V3C3.7998 2.17 4.4698 1.5 5.2998 1.5C6.1298 1.5 6.7998 2.17 6.7998 3V4"
      stroke={color}
      strokeOpacity={0.5}
      strokeWidth={0.8}
      strokeLinecap="round"
    />
  </svg>
);

export default LockIcon;
